/** Properties by which agreement acceptance connections can be ordered. */
export var AgreementAcceptanceOrderField;
(function (AgreementAcceptanceOrderField) {
    AgreementAcceptanceOrderField["createdAt"] = "createdAt";
    AgreementAcceptanceOrderField["updatedAt"] = "updatedAt";
})(AgreementAcceptanceOrderField || (AgreementAcceptanceOrderField = {}));
/** Status of agreement acceptance. */
export var AgreementAcceptanceStatus;
(function (AgreementAcceptanceStatus) {
    AgreementAcceptanceStatus["ACCEPTED"] = "ACCEPTED";
    AgreementAcceptanceStatus["REJECTED"] = "REJECTED";
})(AgreementAcceptanceStatus || (AgreementAcceptanceStatus = {}));
/** Properties by which agreement connections can be ordered. */
export var AgreementOrderField;
(function (AgreementOrderField) {
    AgreementOrderField["createdAt"] = "createdAt";
    AgreementOrderField["name"] = "name";
    AgreementOrderField["updatedAt"] = "updatedAt";
})(AgreementOrderField || (AgreementOrderField = {}));
/** The records AgreementStatus (ACTIVE or DELETED). */
export var AgreementStatus;
(function (AgreementStatus) {
    AgreementStatus["ACTIVE"] = "ACTIVE";
    AgreementStatus["DELETED"] = "DELETED";
})(AgreementStatus || (AgreementStatus = {}));
/** The Auth Algorithm. */
export var AuthAlgorithm;
(function (AuthAlgorithm) {
    AuthAlgorithm["HMAC_SHA_256"] = "HMAC_SHA_256";
    AuthAlgorithm["HMAC_SHA_384"] = "HMAC_SHA_384";
    AuthAlgorithm["HMAC_SHA_512"] = "HMAC_SHA_512";
})(AuthAlgorithm || (AuthAlgorithm = {}));
/** Properties by which auth events connections can be ordered. */
export var AuthEventOrderField;
(function (AuthEventOrderField) {
    AuthEventOrderField["createdAt"] = "createdAt";
})(AuthEventOrderField || (AuthEventOrderField = {}));
/** The Auth Event Type. */
export var AuthEventType;
(function (AuthEventType) {
    AuthEventType["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    AuthEventType["LOGIN"] = "LOGIN";
    AuthEventType["REFRESH_TOKEN"] = "REFRESH_TOKEN";
    AuthEventType["RESET_PASSWORD_COMPLETE"] = "RESET_PASSWORD_COMPLETE";
    AuthEventType["RESET_PASSWORD_START"] = "RESET_PASSWORD_START";
})(AuthEventType || (AuthEventType = {}));
/** The Org Auth Config Cookie Type. */
export var CookieType;
(function (CookieType) {
    CookieType["SET_COOKIE"] = "SET_COOKIE";
    CookieType["SET_HEADER"] = "SET_HEADER";
    CookieType["SET_URL_PARAMS"] = "SET_URL_PARAMS";
})(CookieType || (CookieType = {}));
/** Properties by which person connections can be ordered. */
export var DesignationOrderField;
(function (DesignationOrderField) {
    DesignationOrderField["createdAt"] = "createdAt";
    DesignationOrderField["description"] = "description";
    DesignationOrderField["updatedAt"] = "updatedAt";
})(DesignationOrderField || (DesignationOrderField = {}));
/** The records DesignationStatus (ACTIVE or DELETED). */
export var DesignationStatus;
(function (DesignationStatus) {
    DesignationStatus["ACTIVE"] = "ACTIVE";
    DesignationStatus["DELETED"] = "DELETED";
})(DesignationStatus || (DesignationStatus = {}));
/** Properties by which person connections can be ordered. */
export var IdTypeOrderField;
(function (IdTypeOrderField) {
    IdTypeOrderField["createdAt"] = "createdAt";
    IdTypeOrderField["description"] = "description";
    IdTypeOrderField["updatedAt"] = "updatedAt";
})(IdTypeOrderField || (IdTypeOrderField = {}));
/** The records IdTypeStatus (ACTIVE or DELETED). */
export var IdTypeStatus;
(function (IdTypeStatus) {
    IdTypeStatus["ACTIVE"] = "ACTIVE";
    IdTypeStatus["DELETED"] = "DELETED";
})(IdTypeStatus || (IdTypeStatus = {}));
/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["asc"] = "asc";
    OrderDirection["desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
/** The Org Auth Config Type. */
export var OrgAuthConfigType;
(function (OrgAuthConfigType) {
    OrgAuthConfigType["AWS_COGNITO"] = "AWS_COGNITO";
    OrgAuthConfigType["IDENTITY_PROVIDER"] = "IDENTITY_PROVIDER";
    OrgAuthConfigType["VERID_OPEN_ID"] = "VERID_OPEN_ID";
    OrgAuthConfigType["VERID_USER_ID_AND_PASSWORD"] = "VERID_USER_ID_AND_PASSWORD";
})(OrgAuthConfigType || (OrgAuthConfigType = {}));
/** Properties by which org connections can be ordered. */
export var OrgOrderField;
(function (OrgOrderField) {
    OrgOrderField["createdAt"] = "createdAt";
    OrgOrderField["name"] = "name";
    OrgOrderField["updatedAt"] = "updatedAt";
})(OrgOrderField || (OrgOrderField = {}));
/** The Relationship Type Between Two Organizations */
export var OrgRelation;
(function (OrgRelation) {
    OrgRelation["PROVIDER1_APP2"] = "PROVIDER1_APP2";
    OrgRelation["PROVIDER1_JURISDICTION2"] = "PROVIDER1_JURISDICTION2";
})(OrgRelation || (OrgRelation = {}));
/** The records OrgStatus (ACTIVE or DELETED). */
export var OrgStatus;
(function (OrgStatus) {
    OrgStatus["ACTIVE"] = "ACTIVE";
    OrgStatus["DELETED"] = "DELETED";
})(OrgStatus || (OrgStatus = {}));
/** The Organization Type. */
export var OrgType;
(function (OrgType) {
    OrgType["APP"] = "APP";
    OrgType["JURISDICTION"] = "JURISDICTION";
    OrgType["PROVIDER"] = "PROVIDER";
})(OrgType || (OrgType = {}));
/** Properties by which person connections can be ordered. */
export var PersonOrderField;
(function (PersonOrderField) {
    PersonOrderField["createdAt"] = "createdAt";
    PersonOrderField["firstName"] = "firstName";
    PersonOrderField["lastName"] = "lastName";
    PersonOrderField["updatedAt"] = "updatedAt";
})(PersonOrderField || (PersonOrderField = {}));
/** Properties by which person org connections can be ordered. */
export var PersonOrgOrderField;
(function (PersonOrgOrderField) {
    PersonOrgOrderField["createdAt"] = "createdAt";
    PersonOrgOrderField["firstName"] = "firstName";
    PersonOrgOrderField["lastName"] = "lastName";
    PersonOrgOrderField["updatedAt"] = "updatedAt";
})(PersonOrgOrderField || (PersonOrgOrderField = {}));
/** The records PersonOrgStatus (ACTIVE or DELETED). */
export var PersonOrgStatus;
(function (PersonOrgStatus) {
    PersonOrgStatus["ACTIVE"] = "ACTIVE";
    PersonOrgStatus["DELETED"] = "DELETED";
})(PersonOrgStatus || (PersonOrgStatus = {}));
/** The records PersonStatus (ACTIVE or DELETED). */
export var PersonStatus;
(function (PersonStatus) {
    PersonStatus["ACTIVE"] = "ACTIVE";
    PersonStatus["DELETED"] = "DELETED";
})(PersonStatus || (PersonStatus = {}));
/** User role */
export var Role;
(function (Role) {
    Role["ADMIN"] = "ADMIN";
    Role["STAFF"] = "STAFF";
    Role["USER"] = "USER";
})(Role || (Role = {}));
/** Properties by which team member connections can be ordered. */
export var TeamMemberOrderField;
(function (TeamMemberOrderField) {
    TeamMemberOrderField["createdAt"] = "createdAt";
    TeamMemberOrderField["lastName"] = "lastName";
    TeamMemberOrderField["updatedAt"] = "updatedAt";
})(TeamMemberOrderField || (TeamMemberOrderField = {}));
/** The records TeamMemberStatus (ACTIVE or DELETED). */
export var TeamMemberStatus;
(function (TeamMemberStatus) {
    TeamMemberStatus["ACTIVE"] = "ACTIVE";
    TeamMemberStatus["DELETED"] = "DELETED";
})(TeamMemberStatus || (TeamMemberStatus = {}));
/** Properties by which team connections can be ordered. */
export var TeamOrderField;
(function (TeamOrderField) {
    TeamOrderField["createdAt"] = "createdAt";
    TeamOrderField["name"] = "name";
    TeamOrderField["updatedAt"] = "updatedAt";
})(TeamOrderField || (TeamOrderField = {}));
/** Team role */
export var TeamRole;
(function (TeamRole) {
    TeamRole["ADMIN"] = "ADMIN";
    TeamRole["STAFF"] = "STAFF";
})(TeamRole || (TeamRole = {}));
/** The records TeamStatus (ACTIVE or DELETED). */
export var TeamStatus;
(function (TeamStatus) {
    TeamStatus["ACTIVE"] = "ACTIVE";
    TeamStatus["DELETED"] = "DELETED";
})(TeamStatus || (TeamStatus = {}));
/** Properties by which verification methods connections can be ordered. */
export var VerificationMethodOrderField;
(function (VerificationMethodOrderField) {
    VerificationMethodOrderField["createdAt"] = "createdAt";
    VerificationMethodOrderField["name"] = "name";
    VerificationMethodOrderField["updatedAt"] = "updatedAt";
})(VerificationMethodOrderField || (VerificationMethodOrderField = {}));
/** The records VerificationMethodStatus (ACTIVE or DELETED). */
export var VerificationMethodStatus;
(function (VerificationMethodStatus) {
    VerificationMethodStatus["ACTIVE"] = "ACTIVE";
    VerificationMethodStatus["DELETED"] = "DELETED";
})(VerificationMethodStatus || (VerificationMethodStatus = {}));
/** The Verification Method Type. */
export var VerificationMethodType;
(function (VerificationMethodType) {
    VerificationMethodType["MANUAL"] = "MANUAL";
    VerificationMethodType["OPEN_ID"] = "OPEN_ID";
    VerificationMethodType["PERSONAL_KNOWLEDGE"] = "PERSONAL_KNOWLEDGE";
    VerificationMethodType["SELF_DECLARED"] = "SELF_DECLARED";
    VerificationMethodType["SELF_SOVEREIGN_IDENTITY"] = "SELF_SOVEREIGN_IDENTITY";
})(VerificationMethodType || (VerificationMethodType = {}));
/** The Verification Status. */
export var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["PENDING"] = "PENDING";
    VerificationStatus["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
    VerificationStatus["VERIFIED"] = "VERIFIED";
})(VerificationStatus || (VerificationStatus = {}));
